import { z } from 'zod'

export const COACHING_ZOOM_OAUTH_CONTRACT_VERSION = '1.0.0' as const
export const coachingZoomOAuthResponseSchema = z.unknown()
export type CoachingZoomOAuthResponse = z.infer<typeof coachingZoomOAuthResponseSchema>
